import { SDEventTypesCountedAs } from "types/staticData.types"
import * as Yup from "yup"

export const SDEventTypesInitialValues = {
	name: "",
	description: "",
	countedAs: SDEventTypesCountedAs.WORK,
	scheduledToEmployee: false,
	scheduledToPost: false,
	resultsInPay: false,
	resultsInBill: false,
	isEnabled: false,
}

export const SDEventTypesSchema = Yup.object().shape({
	name: Yup.string().required().label("Name"),
	description: Yup.string().required().label("Description"),
	countedAs: Yup.string().notRequired().label("Counted As"),
	scheduledToEmployee: Yup.boolean().notRequired().label("Scheduled to Employee"),
	scheduledToPost: Yup.boolean().notRequired().label("Scheduled to Post"),
	resultsInPay: Yup.boolean().notRequired().label("Results in Pay"),
	resultsInBill: Yup.boolean().notRequired().label("Results in Bill"),
	isEnabled: Yup.boolean().notRequired().label("Enabled"),
})
